module.exports = __webpack_public_path__ + "media/fonts/Aleo-Italic-151d3de7a79dfcd79ed10fa79513c966.ttf";